import React, { createContext, useContext, useMemo, useState } from 'react';

const ShareChromeContext = createContext({
  chatOnly: false,
  setChatOnly: () => {},
});

export function ShareChromeProvider({ children }) {
  const [chatOnly, setChatOnly] = useState(false);
  const value = useMemo(() => ({ chatOnly, setChatOnly }), [chatOnly]);
  return (
    <ShareChromeContext.Provider value={value}>
      {children}
    </ShareChromeContext.Provider>
  );
}

export function useShareChrome() {
  return useContext(ShareChromeContext);
}
